import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { WebhookEventsFacade } from '../../../../../Facades/Ops/webhook-events.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { WebhookEventFilters } from '../../../../../Interfaces/api/backoffice/webhook-event.interface';

@Component({
  selector: 'app-webhook-events',
  standalone: true,
  imports: [
    DatePipe,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
  ],
  templateUrl: './webhook-events.component.html',
  styleUrl: './webhook-events.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class WebhookEventsComponent {
  readonly facade = inject(WebhookEventsFacade);

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;

  readonly isEmpty = computed<boolean>(
    () => this.facade.state() === 'ready' && this.facade.events().length === 0,
  );

  changeFilter(field: keyof WebhookEventFilters, value: string): void {
    this.facade.applyFilters({ ...this.facade.filters(), [field]: value });
  }

  clearFilters(): void {
    this.facade.clearFilters();
  }

  selectEvent(eventId: string): void {
    this.facade.selectEvent(eventId);
  }

  replay(eventId: string): void {
    this.facade.replay(eventId);
  }

  goToPage(page: number): void {
    this.facade.goToPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }

  reload(): void {
    this.facade.reload();
  }
}
